import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  openSideMenu(_e) {
    const mobileMenu = document.getElementById('side_mobile_menu')
    if (mobileMenu) return mobileMenu.show()
  }
}
